import React from 'react'
import Flexbox from 'flexbox-react'
import { observer, inject } from 'mobx-react'
import cfaBackground from '../../assets/CFA_branded_Side_Panel.png'
import HallPanelShopList from './hall_panel_shop_list'
import QRCode from 'react-qr-code'
import {GraphikFont} from '../../constants'

const QR_COLOR = '#DD0033'
const QR_LEVEL = 'H'

const HallPanelCfaQr = ({ RootStore }) => {
  const { configStore, styleStore: { currentStylesDict }, hallStore, generateGrubhubAppDeepLink } = RootStore

  return (
    <Flexbox
      id={'container2'}
      className={currentStylesDict.hallPanelMainBackgroundClassName}
      style={{ ...currentStylesDict.hallPanelMainBackgroundColor, backgroundImage: `url(${cfaBackground})`, ...styles.container }}
    >
      <Flexbox style={styles.qrCodeDiv}>
        <Flexbox style={styles.qrCode}>
          <QRCode
            value={generateGrubhubAppDeepLink()}
            level={QR_LEVEL}
            fgColor={QR_COLOR}
            style={styles.qrImage}
          />
          <div style={styles.qrCodeText}>
            {configStore.qrCode}
          </div>
        </Flexbox>
      </Flexbox>
      <Flexbox id={'container3'} width='100%' flex={'1'} style={styles.shopPanelShopList}>
        <HallPanelShopList />
      </Flexbox>
      <Flexbox width='100%' height='1%' />
      <Flexbox width='100%' height='6%' style={styles.hallPanelShopListNumber}>
        <div style={styles.autoMargin}>
          {hallStore.hallPanelShopListFooter}
        </div>
      </Flexbox>
    </Flexbox>
  )
}

const styles = {
  container: {
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    backgroundSize: 'cover',
    position: 'relative',
  },
  qrCodeDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  qrCode: {
    flexDirection: 'column',
    position: 'absolute',
    bottom: '12%',
    right: '14%',
    width: '25%',
    height: '21%',
    alignItems: 'center',
  },
  shopPanelShopList: {
    margin: '0 auto',
    fontSize: '2vh',
  },
  hallPanelShopListNumber: {
    fontSize: '2.8vh',
    fontFamily: GraphikFont.REGULAR,
  },
  autoMargin: {
    margin: 'auto',
  },
  qrCodeText: {
    fontFamily: GraphikFont.SEMI_BOLD,
    fontSize: '2.5vw',
    marginTop: '0.5rem',
  },
  qrImage: {
    backgroundColor: 'white',
    padding: '0.5rem',
    display: 'flex',
    width: '100%',
    height: 'auto',
  },
}

export default inject('RootStore')(observer(HallPanelCfaQr))



// WEBPACK FOOTER //
// ./src/components/shop_panel/hall_panel_cfa_qr.jsx